import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let status: string = '';
    switch (value) {
      case '10':
        status = 'Paid';
        break;
      default:
        status = 'Pending';
    }
    return status;
  }

}



// WEBPACK FOOTER //
// ./src/app/status.pipe.ts